import React from "react";
import Grid from "@mui/material/Unstable_Grid2";
import Box from "@mui/material/Box";
import { Stack, Typography } from "@mui/material";

const Taller_Form_Header = ({ formData, isLoading }) => {
  const date_created = formData.date_created;
  const dateAnalisisAdmin = formData.fecha_analisis_admin;

  let dateStr = "",
    timeStr = "",
    dateAnalisis = "",
    dateStr_Meli = "";

  if (!isNaN(Date.parse(date_created))) {
    const dateObject = new Date(date_created);
    const dateObject_Analisis = new Date(dateAnalisisAdmin);
    const dateObject_meli = new Date(formData.devoluciones_fecha_entregado);

    const argentinaTime = new Date(dateObject.getTime() - 3 * 60 * 60 * 1000);
    const argentinaTime_Analisis = new Date(
      dateObject_Analisis.getTime() - 3 * 60 * 60 * 1000,
    );

    dateStr = argentinaTime.toISOString().split("T")[0];
    timeStr = argentinaTime.toTimeString().split(" ")[0].substring(0, 5);
    dateAnalisis = argentinaTime_Analisis.toISOString().split("T")[0];
    dateStr_Meli = dateObject_meli.toISOString().split("T")[0];
  } else {
    console.error("Fecha no válida:", date_created);
  }

  const fields = [
    { label: "N° Seguimiento", value: formData.envios_numero_de_seguimiento },
    { label: "N° Venta", value: formData.ventas_num_de_venta },
    { label: "SKU", value: formData.publicaciones_sku },
    { label: "Fecha de Ingreso", value: `${dateStr} ${timeStr}` },
    { label: "Fecha Devolución", value: dateStr_Meli },

    { label: "Origen Devolución", value: formData.origen_devolucion_name },
    { label: "Destino Devolución", value: formData.deposito_destino_name },
    // { label: "Condición", value: formData.condition_name },
    { label: "Síntoma", value: formData.sintoma_name },
    // {
    //   label: "Aceptamos Devolución",
    //   value: formData.aceptamos_devolucion_name,
    // },
    { label: "Fecha de Análisis", value: dateAnalisis },
    // { label: "Movimiento VS Inicial", value: formData.movimientos_vs_inicial },
  ];

  const labelSx = {
    fontWeight: "semi-bold",
    fontSize: "14px",
    lineHeight: "24px",
    letterSpacing: "0.15px",
    color: "#00000061",
  };

  const valueSx = {
    fontWeight: "normal",
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.15px",
    color: "#000000DE",
  };

  return (
    <>
      {!isLoading && (
        <Box
          sx={{
            flexGrow: 1,
            border: "1px solid #0000003B",
            borderRadius: "4px",
            padding: "16px",
            gap: "16px",
            flexDirection: "column",
            display: "flex",
          }}
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: "semi-bold",
                fontSize: "16px",
                lineHeight: "24px",
                letterSpacing: "0.15px",
                color: "#424242",
              }}
            >
              📦 DATOS DEL PRODUCTO
            </Typography>
          </Stack>
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            {fields.map(({ label, value }) => (
              <Grid
                item
                xs={12}
                sm={4}
                md={4}
                key={label}
                sx={{ display: "flex", flexDirection: "column" }}
              >
                <Typography variant="caption" sx={labelSx}>
                  {label}
                </Typography>
                <Typography variant="caption" sx={valueSx}>
                  {value}
                </Typography>
              </Grid>
            ))}
          </Grid>
        </Box>
      )}
    </>
  );
};

export default Taller_Form_Header;
